import { render, staticRenderFns } from "./SeminarCard.vue?vue&type=template&id=04823069&scoped=true&"
import script from "./SeminarCard.vue?vue&type=script&lang=ts&"
export * from "./SeminarCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04823069",
  null
  
)

export default component.exports